<!-- Da dinamic form module -->
<ng-container *ngIf="group && field">
    <div class="main-outer-container" [formGroup]="group" [hidden]="field.hidden ? field.hidden: false">
        <div class="flex-col flex align-top my-2">

            <label for="{{field.name}}" [hidden]="field.hidden ? field.hidden: false" class="label flex ">
                {{field.label}}
            </label>

            <!-- <ejs-switch [id]="field.name" [formControlName]="field.name" #switchI (change)="onChange($event)">
            </ejs-switch> -->


            <mat-slide-toggle [id]="field.name" [formControlName]="field.name" #switchI (change)="onChange($event)"></mat-slide-toggle>
        </div>
        <!--OLD ngIf *ngIf="group.controls[field.name].dirty && group.controls[field.name].invalid"-->
        <div class="flex flex-col align-top"
            *ngIf="group && field && group.controls[field!.name].dirty || group.controls[field!.name].touched">
            <!--<ejs-message *ngFor="let validation of field.validations; let i = index;">

            </ejs-message>-->
            <ng-container *ngFor="let validation of field.validations; let i = index;">
                <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError(validation.name)"
                    class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                        <path d="M12 8v4" />
                        <path d="M12 16h.01" />
                    </svg>

                    <p>{{validation.message}}</p>
                </div>
            </ng-container>
            <!--<ng-container *ngFor="let validation of field.validations; let i = index;">
                <div *ngIf="group && field && group.controls[field.name].hasError(validation.name)"
                    class="error-msg"
                >
                {{validation.message}}&nbsp;&nbsp;
                </div>
            </ng-container>-->
        </div>

    </div>
</ng-container>

<!-- Da app con componente core -->
<ng-container *ngIf="!group">
    <div class="flex-col">
        <ejs-switch (change)="onChange($event)" cssClass="e-large" [(ngModel)]="switchValue" #switchI></ejs-switch>
    </div>
</ng-container>